import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from './sites/Login.js';
import HomePage from './sites/HomePage.js';
import './App.css';
import PrivateRoutes from "./privateRoutes";




function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/*The PrivateRoutes component is executed on every path*/}
                <Route element={<PrivateRoutes />}>
                    <Route element={<HomePage />} path='/' />
                </Route>
                <Route path="/login" element={<Login />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
